let result;

export const getStroeerGalleryBanners = () => {
  if (result) return Promise.resolve(result);
  return import('./adv-stroeer-mobile-gallery').then((module) => {
    result = module;
    return module;
  });
};